import {callAgain, sendPitchProjectURL, sendPitchStrategyURL} from "../../services/api";
import api from '../../services/instanceapi';
import {MESSAGE_IS_PENDING, SEND_MESSAGE, SEND_MESSAGE_FAIL} from "../message/actions/actionTypes";
import {checkErrorMessage} from "../../utils/utils";


export const callSbAgain = (data) => async (dispatch) => {
    dispatch({
        type:MESSAGE_IS_PENDING
    })
    try {
        const res = await api.post(callAgain(), data);
        dispatch({
            type: SEND_MESSAGE,
            payload: {
                status: res.status,
                message: res.statusText
            }
        })
        return Promise.resolve();
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: SEND_MESSAGE_FAIL,
                payload: {
                    message: message,
                    status: status
                },
            });
        }

        return Promise.reject(e)
    }
}

export const sendPitchProject = (project_id, members_id) => async (dispatch) => {
    dispatch({
        type:MESSAGE_IS_PENDING
    })
    try {
        const axis = await api.post(sendPitchProjectURL(project_id), members_id);
        dispatch({
            type: SEND_MESSAGE,
            payload: {
                status: axis.status,
                message: axis.statusText
            }
        })
        return Promise.resolve();
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: SEND_MESSAGE_FAIL,
                payload: {
                    message: message,
                    status: status
                },
            });
        }
        return Promise.reject(e)
    }
}
export const sendPitchStrategy = (members_id) => async (dispatch) => {
    dispatch({
        type:MESSAGE_IS_PENDING
    })
    try {
        const axis = await api.post(sendPitchStrategyURL(), members_id);
        dispatch({
            type: SEND_MESSAGE,
            payload: {
                status: axis.status,
                message: axis.statusText
            }
        })
        return Promise.resolve();
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: SEND_MESSAGE_FAIL,
                payload: {
                    message: message,
                    status: status
                },
            });
        }
        return Promise.reject(e)
    }
}